// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".czt-map-widget__load-poi{position:absolute !important;bottom:15px !important;z-index:750 !important;left:50%;transform:translate3d(-50%, 0, 0)}", ""]);
// Exports
module.exports = exports;
